import React from "react";
import loadable from "@loadable/component";
import AniLink from "gatsby-plugin-transition-link/AniLink";

import SplashText from "../../components/SplashText";
import useMediaQuery from "../../hooks/use-media-query";
import { breakpoints, colors } from "../../../theme";
import {
  Section,
  Heading,
  BlogListStack,
  BlogPostsGrid,
  StyledButton,
  ComingSoonText,
} from "./styles";
import BlogCardsSkeleton from "./blog-cards-skeleton";

const BlogCards = loadable(() => import("./blog-cards"));

const BlogSection = ({
  blogPosts,
  title = "Blog",
  compensateHeaderGap = false,
  preview = false,
  variant = "normal",
}) => {
  const isSmallDesktop = useMediaQuery(
    `(min-width: ${breakpoints.desktop}) and (max-width: 1260px)`,
  );

  const isVeryLargeDesktop = useMediaQuery("(min-width: 2000px)");

  const previewLimit = () => {
    if (isSmallDesktop || isVeryLargeDesktop) {
      return 4;
    }
    return 3;
  };

  const visibleCount = preview ? previewLimit() : blogPosts.length;

  const shouldViewAllRender =
    preview &&
    blogPosts.length !== 0 &&
    blogPosts.length > previewLimit();

  const visiblePosts = blogPosts.slice(0, visibleCount);
  const isEmpty = blogPosts.length === 0;

  return (
    <Section
      name="blog"
      as="section"
      $flushBottom={variant === "wide"}
      $compensateHeaderGap={compensateHeaderGap}
    >
      <Heading as={preview ? "h2" : "h1"}>
        <SplashText variant="accent">{title}</SplashText>
      </Heading>
      <BlogListStack $hasViewAll={shouldViewAllRender}>
        {isEmpty ? (
          <BlogPostsGrid isEmpty variant={variant}>
            <ComingSoonText>Coming soon!</ComingSoonText>
          </BlogPostsGrid>
        ) : (
          <BlogCards
            fallback={
              <BlogCardsSkeleton count={visibleCount} variant={variant} />
            }
            posts={visiblePosts}
            variant={variant}
          />
        )}
        {shouldViewAllRender && (
          <StyledButton
            forwardedAs={AniLink}
            cover
            bg={colors.black}
            to="/blog/"
          >
            View all
          </StyledButton>
        )}
      </BlogListStack>
    </Section>
  );
};

export default BlogSection;
